import type { useTranslation } from "react-i18next";

type TFunction = ReturnType<typeof useTranslation>["t"];

export function getAuthErrorMessage(code: string, t: TFunction): string {
  switch (code) {
    case "auth/user-not-found":
    case "auth/invalid-credential": return t("auth.errorInvalidCredential");
    case "auth/wrong-password":     return t("auth.errorWrongPassword");
    case "auth/email-already-in-use":
    case "auth/credential-already-in-use": return t("auth.errorCredentialInUse");
    case "auth/weak-password":      return t("auth.errorWeakPassword");
    case "auth/invalid-email":      return t("auth.errorInvalidEmail");
    default:                        return t("auth.errorGeneric");
  }
}
